$(document).on('scroll', function(e){
	if ($('.js-prodInfo').length) {
		let scrollTop = $(this).scrollTop(),
			prodInfo = $('.js-prodInfo'),
			prodInfoPos = prodInfo.offset().top,
			prodInfoContent = $('.product-info');

		(scrollTop >= prodInfoPos) ? prodInfoContent.addClass("sticky") : prodInfoContent.removeClass("sticky");
	}

	if ($('.header').length) {
		let	header = $('.header'),
			headerPos = header.offset().top,
			pos = $(this).scrollTop();
		
		if (pos >= headerPos)
			header.addClass('sticky');
		else
			header.removeClass('sticky');
	}

	if ($('.js-asideSticky').length) {
		let scrollTop = $(this).scrollTop(),
			target = $('.js-asideSticky'),
			targetParent = target.closest('.js-parent'),
			targetParentPos = targetParent.offset().top;

		(scrollTop >= targetParentPos) ? targetParent.addClass("sticky") : targetParent.removeClass("sticky");
	}
});
